import React, { useRef, useState } from 'react';
import bg1 from 'images/solution-bg1.png';
import bg2 from 'images/solution-bg2.png';
import bg3 from 'images/solution-bg3.png';
import bg4 from 'images/solution-bg4.png';
import bg5 from 'images/solution-bg5.png';
import bg6 from 'images/solution-bg6.png';
import icon1 from 'images/solution-icon1.png';
import icon2 from 'images/solution-icon2.png';
import icon3 from 'images/solution-icon3.png';
import icon4 from 'images/solution-icon4.png';
import icon5 from 'images/solution-icon5.png';
import icon6 from 'images/solution-icon6.png';

const solutionList = [
  {
    title: '营销建站',
    desc: '分行业的定制建站能力、助力营销转化提升',
    icon: icon1,
    bg: bg1,
  },
  {
    title: '创意制作',
    desc: '提供优质素材资源、推荐热门创意、批量生成创意',
    icon: icon2,
    bg: bg2,
  },
  {
    title: '人群定向',
    desc: '细分场景的智能人群定向能力',
    icon: icon3,
    bg: bg3,
  },
  {
    title: '广告投放',
    desc: '打造智能化投放能力，提升投放效率和效果',
    icon: icon4,
    bg: bg4,
  },
  {
    title: '效果监测',
    desc: '多维度、跨账户的广告效果监测和分析',
    icon: icon5,
    bg: bg5,
  },
  {
    title: '私域营销',
    desc: '私域用户的管理、分析和营销，助力交易增长',
    icon: icon6,
    bg: bg6,
  },
];

const Solutions: React.FC = () => {
  const [current, setCurrent] = useState<number>(0);
  const timeout = useRef<ReturnType<typeof setTimeout>>();

  const handleMouseEnter = (e: React.MouseEvent<HTMLDivElement>) => {
    const index = +e.currentTarget.dataset.index;

    if (timeout.current) {
      clearTimeout(timeout.current);
      timeout.current = setTimeout(() => {
        timeout.current = null;
        setCurrent(index);
      }, 200);
      return;
    }

    setCurrent(index);
    timeout.current = setTimeout(() => {
      timeout.current = null;
    }, 200);
  };

  return (
    <section className="solutions">
      <div className="fade text-bold header">全链路方案</div>
      <div className="fade text-bold sub-header">COMPREHENSIVE SOLUTIONS</div>

      <div className="fade flex-list">
        {solutionList?.map(({ title, desc, icon, bg }, index) => (
          <div
            key={title}
            className={`solution-item ${current === index ? 'active' : ''}`}
            style={{ backgroundImage: `url("${bg}"), linear-gradient(0, #fff, #fff)` }}
            data-index={index}
            onMouseEnter={handleMouseEnter}
          >
            <div className="front">
              <img src={icon} alt={title} />
              <div className="text-bold">{title}</div>
            </div>
            <div className="back">
              <div className="text-bold">{title}</div>
              <div className="desc">{desc}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Solutions;
